import { COUNTRIES } from '@wareclouds/frontend-common';

import { CONTEXT } from '@/config/consts/commons';

import { REGISTRATION_SECTION_KEYS } from './registration.constants';

export const IS_BR = CONTEXT === COUNTRIES.BR;

export const VEHICLE_TYPES_CL = ['auto', 'furgon', 'moto', 'suv', 'camioneta'];

export const VEHICLE_TYPES_BR = ['carro', 'furgao', 'moto'];

export const VEHICLE_TYPES = IS_BR ? VEHICLE_TYPES_BR : VEHICLE_TYPES_CL;

export const SECTION_CONFIG = {
  'personal-info': { index: 1, key: REGISTRATION_SECTION_KEYS.PERSONAL_INFO },
  'vehicle-info': { index: 2, key: REGISTRATION_SECTION_KEYS.VEHICLE_INFO },
  'drivers-license': {
    index: 3,
    key: REGISTRATION_SECTION_KEYS.DRIVERS_LICENSE,
  },
};
